import React from 'react';
import { bool } from 'prop-types';
import { get } from 'lodash';
import { FormattedMessage, intlShape } from 'react-intl';
import { formatMoney } from '../../util/currency';
import {
  propTypes,
  LINE_ITEM_GUEST_LIABILITY_PROTECTION,
  LINE_ITEM_LT_PLUS_GLP_WAIVER,
} from '../../util/types';
import { types as sdkTypes } from '../../util/sdkLoader';

import css from './LineItemGuestLiabilityProtection.module.css';

const { Money } = sdkTypes;

const LineItemGuestLiabilityProtection = props => {
  const { transaction, isCustomer, intl, forceWaived } = props;

  if (!isCustomer) {
    return null;
  }

  const lineItems = transaction?.attributes?.lineItems || [];
  const protectionLineItem = lineItems.find(
    item => item.code === LINE_ITEM_GUEST_LIABILITY_PROTECTION && !item.reversal
  );

  if (!protectionLineItem) {
    return null;
  }

  const waiverLineItem = lineItems.find(
    item => item.code === LINE_ITEM_LT_PLUS_GLP_WAIVER && !item.reversal
  );
  const isWaived =
    forceWaived ||
    !!waiverLineItem ||
    get(transaction, 'attributes.protectedData.guestLiabilityProtection.waived', false);

  const protectionFee = protectionLineItem.lineTotal;
  const formattedProtectionFee = protectionFee ? formatMoney(intl, protectionFee) : null;

  if (!isWaived) {
    return (
      <div className={css.lineItem}>
        <span className={css.itemLabel}>
          <FormattedMessage
            id="BookingBreakdown.guestLiabilityProtection"
            defaultMessage="Guest Liability Protection"
          />
        </span>
        <span className={css.itemValue}>{formattedProtectionFee}</span>
      </div>
    );
  }

  const waivedFee = protectionFee ? new Money(0, protectionFee.currency) : null;
  const formattedWaivedFee = waivedFee ? formatMoney(intl, waivedFee) : null;

  return (
    <div className={css.lineItem}>
      <span className={css.itemLabelGroup}>
        <span className={css.itemLabel}>
          <FormattedMessage
            id="BookingBreakdown.guestLiabilityProtection"
            defaultMessage="Guest Liability Protection"
          />
        </span>
        <span className={css.itemNote}>
          <FormattedMessage
            id="BookingBreakdown.guestLiabilityProtectionIncluded"
            defaultMessage="Included with LT+"
          />
        </span>
      </span>
      <span className={css.itemValueGroup}>
        <span className={css.originalValue}>{formattedProtectionFee}</span>
        <span className={css.itemValue}>{formattedWaivedFee}</span>
      </span>
    </div>
  );
};

LineItemGuestLiabilityProtection.propTypes = {
  transaction: propTypes.transaction.isRequired,
  isCustomer: bool.isRequired,
  intl: intlShape.isRequired,
  forceWaived: bool,
};

LineItemGuestLiabilityProtection.defaultProps = {
  forceWaived: false,
};

export default LineItemGuestLiabilityProtection;
